import { TableCell, TableRow } from "../design/table";
import moment from "moment";
import { useMatter } from "../contexts/MatterContext";
import ActivityTypeBadge from "./ActivityTypeBadge";
import { Activity } from "../models/Activity";
import { Avatar } from "../design/avatar";

interface ActivityListItemProps {
  activity: Activity;
}

const ActivityListItem: React.FC<ActivityListItemProps> = ({ activity }) => {
  const href = () => {
    if (activity.data?.file) {
      return `/file/${activity.data.file}`;
    } else if (activity.data?.eventId) {
      return `/event/${activity.data.event}`;
    } else if (activity.data?.participantId) {
      return `/matter/${activity.data.participant}`;
    }
    return undefined;
  };

  const { user } = activity;

  return (
    <TableRow href={href()}>
      <TableCell>
        <div className="flex items-center gap-4">
          {/* Profile Image */}
          {}
          <Avatar
            src={activity?.user?.avatarUrl}
            initials={user?.firstName?.charAt(0) ?? user?.email?.charAt(0)} // Fallback to first letter
          />

          {/* Name and Date stacked */}
          <div className="flex flex-col">
            <span className="font-medium">
              {user?.firstName ?? user?.email ?? "Unknown"}
            </span>
            <span className="text-sm text-gray-500">
              {moment(activity.createdAt).format("llll")}
            </span>
          </div>
        </div>
      </TableCell>

      <TableCell>
        <ActivityTypeBadge type={activity.type} />
      </TableCell>
    </TableRow>
  );
};
export default ActivityListItem;
